import { categorySchema, type Category, type CreateCategoryBody } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const postCategory = (body: CreateCategoryBody): Promise<unknown> =>
  apiRequest<unknown>('/categories', { method: 'POST', body });

export const createCategory = async (body: CreateCategoryBody): Promise<Category> =>
  categorySchema.parse(await postCategory(body));
